import styled from 'styled-components';
import { PALETTE } from '@dealstack/shared/lib/common/business/stampDesign';

export const Overlay = styled.div<{ $width: number; $height: number; $inert: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	width: ${({ $width }) => $width}px;
	height: ${({ $height }) => $height}px;
	pointer-events: none;

	& > * {
		pointer-events: ${({ $inert }) => ($inert ? 'none' : 'auto')};
	}
`;

// Above the dragged box (z-index 3), which is see-through while this shows.
export const DropPreviewOutline = styled.div`
	position: absolute;
	box-sizing: border-box;
	z-index: 4;
	border: 2px dashed ${PALETTE.brand};
	border-radius: 6px;
	background: rgba(13, 94, 242, 0.06);

	&& {
		pointer-events: none;
	}
`;
